var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLayout24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 3H2C1 3 0 4 0 5v14c0 1 1 2 2 2h20c1 0 2-1 2-2V5c0-1-1-2-2-2zM2 19V5h4v14H2zm6 0h8V5H8v14zm10 0V5h4v14h-4z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTIyIDNIMkMxIDMgMCA0IDAgNXYxNGMwIDEgMSAyIDIgMmgyMGMxIDAgMi0xIDItMlY1YzAtMS0xLTItMi0yek0yIDE5VjVoNHYxNEgyem02IDBoOFY1SDh2MTR6bTEwIDBWNWg0djE0aC00eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export { SvgLayout24 as ReactComponent };